import {createSelector} from 'reselect';

import {AppState} from '../../configStore';

const selectA11y = (state: AppState) => state.a11y;

export const selectA11yContrast = createSelector(selectA11y, a11y => a11y.contrast);
export const selectA11yOutline = createSelector(selectA11y, a11y => a11y.outline);
